import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, CheckCircle2 } from 'lucide-react';
const names = ['María García', 'Juan Rodríguez', 'Luciana Fernández', 'Carlos Martínez', 'Ana López', 'Diego Sánchez', 'Valentina Ruiz', 'Martín Pérez', 'Camila González', 'Federico Torres', 'Laura Díaz', 'Santiago Morales', 'Paula Romero', 'Nicolás Herrera', 'Florencia Castro'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'Paraná'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(showPopup, 5000);
    // Then show randomly every 8-12 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.floor(Math.random() * 4000) + 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-145">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100,
      scale: 0.9
    }} className="fixed bottom-6 left-6 z-50 bg-slate-900 border border-slate-700 shadow-2xl shadow-black/50 rounded-xl p-4 max-w-sm flex items-start gap-4" data-id="element-146">
          <div className="bg-teal-900/50 p-3 rounded-full border border-teal-500/30 flex-shrink-0" data-id="element-147">
            <ShoppingBag className="w-6 h-6 text-teal-400" data-id="element-148" />
          </div>
          <div data-id="element-149">
            <div className="flex items-center gap-2 mb-1" data-id="element-150">
              <p className="text-white font-bold text-sm" data-id="element-151">{currentData.name}</p>
              <span className="text-slate-400 text-xs" data-id="element-152">
                de {currentData.city}
              </span>
            </div>
            <p className="text-slate-300 text-sm" data-id="element-153">
              acaba de comprar el{' '}
              <span className="text-amber-400 font-semibold" data-id="element-154">
                Kit Ortopedista Pro
              </span>
            </p>
            <div className="flex items-center gap-1 mt-2 text-xs text-teal-500 font-medium" data-id="element-155">
              <CheckCircle2 className="w-3 h-3" data-id="element-156" /> Compra verificada
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}